<template>
  <div class="container bgWhite">
    <div id="printSection">
      <div class="card-body">
        <div>
          <div class="clearfix"></div>
          <table class="wrap-table">
            <tbody>
              <tr>
                <td class="title">
                  <span>NAMA PELAJAR</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform:uppercase">{{FirstName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:200px" class="title">NO. K/P</td>
                <td class="title">:</td>
                <td class="title">{{IdentityNo}}</td>
              </tr>
              <tr>
                <td style="width:200px" class="title">
                  <span>PROGRAM</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform:uppercase">{{ProgrammeName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width:200px" class="title">
                  <span>TARIKH</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform: uppercase">{{InterviewDate}}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 200px" class="title">
                  <span>MASA PENDAFTARAN</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform: uppercase">Dari {{InterviewStartTime}} Hingga {{InterviewEndTime}}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 200px" class="title">
                  <span>PUSAT TEMUDUGA</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform: uppercase">{{InterviewZoneName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 200px" class="title">
                  <span>TEMPAT TEMUDUGA</span>
                </td>
                <td class="title">:</td>
                <td class="title">
                  <span style="text-transform: uppercase">{{InterviewCenterName}}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 210px" class="title" valign=top>
                  <span>ALAMAT TEMPAT TEMUDUGA</span>
                </td>
                <td class="title" valign=top>:</td>
                <td class="title" valign=top>
                  <span style="text-transform: uppercase">{{InterviewCenter.Address1}}<br>{{InterviewCenter.Address2}}<br>{{InterviewCenter.Address3}}<br>{{InterviewCenter.Postcode}}<br>{{InterviewCenter.City}}<br>{{InterviewCenter.State}}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="mt-5">
            <tbody>
              <tr>
                <td>Sila SEMAK dan pastikan SEMUA maklumat yang tertera di atas adalah betul sebelum anda membuat pengesahan tawaran temuduga.</td>
              </tr>
            </tbody>
          </table>
          <table class="mt-5">
            <tbody>
              <tr>
                <td><div class="brand-card-body">
                  <div>
                    <b-button
                        class="float-right mr-3"
                        variant="primary"
                        v-on:click="InsertAppStatusAcceptOfferInterview()"
                      >
                        Terima Tawaran Temuduga
                      </b-button>
                  </div>
                  <div>
                    <b-button
                        class="float-left ml-3"
                        variant="danger"
                        v-on:click="InsertAppStatusRejectOfferInterview()"
                      >
                        Tolak Tawaran Temuduga
                      </b-button>
                  </div>
                </div></td>
              </tr>
            </tbody>
          </table>
          <hr />
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "PersonalDetails",
  components: {
    DefaultOption
  },
  data: function() {
    return {
      Error: false,
      Message: "",

      AppId: 0,
      Intake: 0,
      IdentityNo: "",
      FirstName: "",
      ProgrammeCode: "",
      ProgrammeName: "",
      InstituteId: 0,
      InstituteName: "",
      InstituteNameOther: "",
      InterviewCenterAddress: null,
      InterviewCenterAddress1: null,
      InterviewCenterAddress2: null,
      InterviewCenterAddress3: null,
      InterviewCenterPostcode: null,
      InterviewCenter: {},
      InterviewCenterName: null,
      InterviewDate: null,
      InterviewEndDt: null,
      InterviewEndTime: null,
      InterviewStartDt: null,
      InterviewStartTime: null,
      InterviewZoneName: null,
      FieldId: 0,
      FieldName: "",
      Course1Code: "",
      Course1Name: "",
      CompApproveAmount: null,
      CompBrand: null,
      CompModel: null,

      StatusHistory: {}
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetPersonalDetails();
      await this.GetIntakes();
      await this.GetProposedStudy();
      await this.GetStatusHistory();
    }
  },
  computed: {
    FilteredStatusHistory: {
      get: function() {
        let arr = this.StatusHistory;

        if (this.StatusHistory.length > 0) {
          arr = _.filter(arr, status => {
            return status.TypeId == 2;
          });
        }
        return arr;
      }
    },
    PrintDate: {
      get: function() {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "DD MMM YYYY"
          );
      }
    },
    PrintTime: {
      get: function() {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "hh:mm:ss A"
          );
      }
    }
  },
  methods: {
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
    GetPersonalDetails() {
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then(response => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.AppId = this.info.AppId;
            this.IdentityNo = this.info.IdentityNo;
            this.FirstName = this.info.FirstName;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.info.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then(response => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetProposedStudy() {
      this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then(response => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            console.log(response)
this.InterviewStartDt = response.data.InterviewStartDt;
this.InterviewEndDt = response.data.InterviewEndDt;
this.InterviewDate = this.moment(this.InterviewStartDt).format("DD/MM/YYYY");
this.InterviewStartTime = this.moment(this.InterviewStartDt).format("hh:mm A");
this.InterviewEndTime = this.moment(this.InterviewEndDt).format("hh:mm A");
this.InterviewCenterName = response.data.InterviewCenterName;
this.InterviewZoneName = response.data.InterviewZoneName;
/*
this.InterviewCenterAddress = response.data.InterviewCenterAddress1
                   + "<br>" + response.data.InterviewCenterAddress2
                   + "<br>" + response.data.InterviewCenterAddress3
                   + "<br>" + response.data.InterviewCenterPostcode
                   + "<br>" + response.data.InterviewCenterCity
                   + "<br>" + response.data.InterviewCenterState;
*/
this.InterviewCenter.Address1 = response.data.InterviewCenterAddress1;
this.InterviewCenter.Address2 = response.data.InterviewCenterAddress2;
this.InterviewCenter.Address3 = response.data.InterviewCenterAddress3;
this.InterviewCenter.Postcode = response.data.InterviewCenterPostcode;
this.InterviewCenter.City = response.data.InterviewCenterCity;
this.InterviewCenter.State = response.data.InterviewCenterState;
            this.Intake = this.info.IntakeId;

            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;

            this.InstituteId = this.info.InstituteId;

            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else this.InstituteName = this.info.InstituteName;
            console.log(this.InstituteNameOther = this.info.InstituteNameOther);
            
            this.FieldId = this.info.FieldId;

            if (this.FieldId == 9999)
            this.FieldName = this.info.FieldNameOther;
            else this.FieldName = this.info.FieldName;

            this.Course1Id = this.info.Course1Id;

            if (this.Course1Id == 9999)
            this.Course1Name = this.info.CourseNameOther;
            else this.Course1Name = this.info.Course1Name;

            this.Course1Code = this.info.Course1Code;

            this.CompApproveAmount = this.info.CompApproveAmount;
            this.CompApproveAmount = parseFloat(this.CompApproveAmount).toFixed(
              2
            );
            this.CompModel = this.info.CompModel;
            this.CompPrice = this.info.CompPrice;
            this.CompBrand = this.info.CompBrand;
            
          } else {
            console.log(this.info.detail);
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetStatusHistory() {
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then(response => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.StatusHistory = this.info;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async InsertAppStatusAcceptOfferInterview() {
      const formData = new FormData();
      formData.append("TypeId", 45);

      return this.$API
        .post(this.$InsertAppStatusSA, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            console.log("Update Saved");
            this.GoToHome();
            this.$dialog.alert('Maklumat berjaya disimpan!');
          }
        });
    },
    async InsertAppStatusRejectOfferInterview() {
      const formData = new FormData();
      formData.append("TypeId", 46);

      return this.$API
        .post(this.$InsertAppStatusSA, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            console.log("Update Saved");
            this.GoToHome();
            this.$dialog.alert('Maklumat berjaya disimpan!');
          }
        });
    },
    GoToHome() {
      this.$router.push("/Home");
    },
  }
};
</script>